import React from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick/lib';
import classnames from 'classnames';
import ProductCarouselItem from './ProductCarouselItem';
import { ProductsConstants, Devices, ScreenSizes, DataDtmActions } from '../../../common/Constants';
import TranslationService from '../../../translations';
import { Next, Prev } from '../../../common/ProductCarouselArrows';
import Utils from '../../../common/Utils';
import StringFormatter from '../../../common/StringFormatter';
import Classes from '../../../common/Classes';
import mixpanelConstants from "../../../common/mixpanelConstants";

class ProductCarouselWrapper extends React.Component {
  constructor(props) {
    super(props);
  }

  getProductDirectoryUrl=(productsDirectoryUrlFormat, companyName) => {
    if (productsDirectoryUrlFormat.includes('?')) {
      return StringFormatter.format(
        productsDirectoryUrlFormat
          .concat('&query={3}')
        , this.props.context.showPlanningEnabled, this.props.interfaceLocale, this.props.context.eventEditionId, companyName
      );
    }
    return StringFormatter.format(productsDirectoryUrlFormat.concat('?locale={0}&query={1}'), this.props.interfaceLocale, companyName);
  }

  goToProductPage = (product) => {
    let productsDetailsUrl;
    const { productDetailsUrlFormat } = this.props;
    const environment = Utils.getCurrentEnvironment();
    if (!Utils.isDevEnvironment(environment) && !Utils.isShowEnvironment(environment) && product.name) {
      //replaces spaces with '-' from product name with meaning full name
      let productName = Utils.getSEOFriendlyName(product.name);
      productsDetailsUrl = StringFormatter.format(productDetailsUrlFormat,
          product.exhibitingOrganisationId.concat('.', productName), product.id);

    } else {
      productsDetailsUrl = StringFormatter.format(productDetailsUrlFormat, product.exhibitingOrganisationId, product.id);
    }
    Utils.setLocationHref(productsDetailsUrl);
  };

  shouldShowNavigation = visibleSlides => this.props.products.length > visibleSlides;

  render() {
    const { interfaceLocale, tags, products }  = this.props;
    const translations = TranslationService.getTranslations(interfaceLocale);
    const sliderSettings = {
      nextArrow: <Next fireMixpanelEvent={this.props.fireMixpanelEvent} text={translations.productDetails.nextArrow} tag={tags.navigation} exhibitorId={products[0]?.exhibitingOrganisationId} />,
      prevArrow: <Prev fireMixpanelEvent={this.props.fireMixpanelEvent} text={translations.productDetails.prevArrow} tag={tags.navigation} exhibitorId={products[0]?.exhibitingOrganisationId} data-testid="prev-arrow"/>,
      infinite: false,
      speed: 500,
      slidesToShow: 4,
      slidesToScroll: 4,
      dots: this.shouldShowNavigation(4),
      arrows: this.shouldShowNavigation(4),
      appendDots: (dots) => <li onClick={this.props.fireMixpanelEvent} data-testid="carousel-dot">{dots}</li>,
      draggable: false,
      responsive: [
        {
          breakpoint: ProductsConstants.mobileMaxWidth,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            dots: this.shouldShowNavigation(2),
            arrows: this.shouldShowNavigation(2)
          }
        },
        {
          breakpoint: ProductsConstants.mobileLargeMaxWidth,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            dots: this.shouldShowNavigation(2),
            arrows: this.shouldShowNavigation(2)
          }
        },
        {
          breakpoint: ProductsConstants.laptopMaxWidth,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            dots: this.shouldShowNavigation(3),
            arrows: this.shouldShowNavigation(3)
          }
        },
        {
          breakpoint: ProductsConstants.desktopMaxWidth,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4,
            dots: this.shouldShowNavigation(4),
            arrows: this.shouldShowNavigation(4)
          }
        }
      ]
    };
    const {
      productCarouselLabel
    } = this.props;
    const deviceType = {
      extraLarge: `${Devices.desktop}-${ScreenSizes.large}`,
      large: `${Devices.desktop}-${ScreenSizes.small}`,
      tablet: `${Devices.desktop}-${ScreenSizes.small}`,
      mobile: `${Devices.mobile}-${ScreenSizes.small}`
    };

    return (
      <div>
        {products && products.length > 0 ?
          <div className={Classes.otherProducts}>
            <hr />
            <div>
              <span className={Classes.otherProductsTitle}>{productCarouselLabel}</span>
              {this.props.isProductDirectoryNavigationEnabled ?
                <a
                  id="view-all-products"
                  className={classnames(Classes.pullRight, Classes.viewAllLinkEllipsis)}
                  href={this.getProductDirectoryUrl(this.props.productDirectoryUrlFormat, this.props.companyName)}
                ><span>{translations.productDetails.viewAllProductsLink}</span>
                </a> : null
              }
            </div>
            <Slider {...sliderSettings}>
              {products.map(product => (
                <div
                  key={product.id}
                  data-dtm={tags.productItem}
                  data-dtm-actions={DataDtmActions.view}
                  data-dtm-attributes={JSON.stringify({
                            exhibitorId: product.exhibitingOrganisationId,
                            productId: product.id
                          })}
                >
                  <ProductCarouselItem
                    product={product}
                    translations={translations.profile}
                    onClick={() => {
                              this.goToProductPage(product);
                            }}
                    tags={tags}
                    isEditAllowed={false}
                    classNames={Classes.productCarouselImageContainer}
                    isInnovative={product.isInnovative}
                    deviceType={deviceType}
                    artistDetailsUrlFormat={this.props.artistDetailsUrlFormat}
                    productDetailsUrlFormat={this.props.productDetailsUrlFormat}
                    displayLink
                    imageDataDtm={{
                      tag: tags.productImage,
                      nameTag: tags.productName,
                      attributes: JSON.stringify({
                          exhibitorId: product.exhibitingOrganisationId,
                          productId: product.id
                        })
                    }}
                    mixpanelProps={JSON.stringify({
                      exhibitorId: product.exhibitingOrganisationId,
                      exhibitorName: this.props.companyName,
                      productId: product.id,
                      productName: product.name,
                      packageName: this.props.packageName,
                      component: mixpanelConstants.component.productDetails
                    })}
                  />
                </div>
                  ))}
            </Slider>
          </div> : null}
      </div>
    );
  }
}

ProductCarouselWrapper.propTypes = {
  products: PropTypes.array.isRequired,
  context: PropTypes.shape({
    showPlanningEnabled: PropTypes.bool,
    eventEditionId: PropTypes.string
  }).isRequired,
  fireMixpanelEvent: PropTypes.func,
  companyName: PropTypes.string,
  productDetailsUrlFormat: PropTypes.string.isRequired,
  artistDetailsUrlFormat: PropTypes.string,
  productDirectoryUrlFormat: PropTypes.string.isRequired,
  productCarouselLabel: PropTypes.string.isRequired,
  interfaceLocale: PropTypes.string.isRequired,
  tags: PropTypes.shape({
    productItem: PropTypes.string,
    icon: PropTypes.string,
    section: PropTypes.string
  }).isRequired,
  isProductDirectoryNavigationEnabled: PropTypes.bool.isRequired,
  packageName: PropTypes.string
};


export default ProductCarouselWrapper;
